import type { RootState } from './store';

export const selectSurveyLanguage = (state: RootState) => state.app.surveyLanguage;

export const selectSurveyScreening = (state: RootState) => state.app.surveyScreening;

export const selectPdpaConsent = (state: RootState) => state.app.pdpaConsent;

export const selectUniqueCodeDraft = (state: RootState) => state.app.uniqueCodeDraft;

/** Brand from validated unique code; defaults to Dice before a code is claimed. */
export const selectCodeBrand = (state: RootState) =>
  state.app.uniqueCodeDraft.codeBrand ?? 'Dice';
